export default {"src":"/_next/static/media/crunch.a8cf913b.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};